import React from "react";
import {withTranslation} from "react-i18next";
import BetCard from "./BetCard";
import DrawingResult from "./DrawingResultV2";
import Balance from "../../pages/components/Balance";
import RecentTicket from "./RecentTicket";
import HistoryResult from "./v2/HistoryResult";
import {useLotto5d} from "../../store/lotto5d/Lotto5dContext";
import BettingBoard from "../betting/BettingBoard";


function SaleV2() {
    const lotto = useLotto5d();

    const {
        config: {lotto90PackagePrices},
        user: {userBalance},
        currentBetting,
        ticket,
        fetchCurrentDraw5D,
        renderTicket,
        onClearBetItem,
    } = lotto;

    const bettingProps = {
        ...lotto,
        PackagePrices: lotto90PackagePrices
    }

    return (
        <div className="betting-board lo5d mt-1 lo5d-v1">
            <button id="refresh-draw" className="d-none" onClick={() => fetchCurrentDraw5D()}/>
            {ticket && renderTicket()}
            <div className="m-0">
                <div className="d-flex justify-content-between w-100">
                    <div className="d-flex">
                        <div className="lo90-v1-l-side border">
                            <Balance pendingAmount={userBalance.pendingLotto5d}/>
                            <RecentTicket/>
                        </div>
                        <div className="lo90-v1-mid-side">
                            <DrawingResult />
                        </div>
                        <div className="lo90-v1-r-side border">
                            <div className="w-betting-board">
                                <div className="position-relative pl-pr pr-1">
                                    <div className="row m-0">
                                        <div className="col pl-0 lo5d pr-0">
                                            <BettingBoard {...bettingProps}/>
                                        </div>
                                        {currentBetting.postGroup.length > 0 &&
                                        <div id="betting-item"
                                             className="col bg-tran-white sc-betting position-absolute betting-item-card-white p-0">
                                            <div className="p-1 bg-white rounded text-right border">
                                                <button onClick={onClearBetItem}
                                                        className="border-0 bg-transparent mt-2">
                                                    <i className="feather icon-trash-2 f-25 text-danger"/>
                                                </button>
                                                <BetCard />

                                            </div>

                                        </div>}
                                    </div>
                                </div>
                            </div>
                            <HistoryResult {...lotto}/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default withTranslation()(SaleV2);

